import React, { memo } from "react";
import { PinIcon, ChevronIcon } from "./icons";
import AiAvatar from "./AiAvatar";

export const MODES = {
    ai: {
        key: "ai",
        label: "AI advisor",
        title: "AI property advisor",
        subtitle: "Explore with AI Agent",
        placeholder: "Ask Your AI Property Advisor",
        ariaLabel: "Ask AI property agent",
    },
    manual: {
        key: "manual",
        label: "Manual search",
        title: "Manual search",
        subtitle: "Search by location",
        placeholder: "Enter location to search manually",
        ariaLabel: "Search properties by location",
    },
};

export const ModeTrigger = memo(function ModeTrigger({ mode, open, onToggle, triggerRef }) {
    return (
        <button
            ref={triggerRef}
            type="button"
            className="mode-trigger"
            aria-haspopup="listbox"
            aria-expanded={open}
            aria-label={`Search mode: ${MODES[mode].label}. Click to change.`}
            onClick={onToggle}
        >
      <span className="mode-trigger-icon">
        {mode === "ai" ? <AiAvatar size={24} /> : <PinIcon size={18} />}
      </span>
            <span className="mode-trigger-chevron"><ChevronIcon /></span>
        </button>
    );
});

export const ModeMenu = memo(function ModeMenu({ mode, onSelect, menuRef }) {
    return (
        <div className="mode-menu" role="listbox" ref={menuRef}>
            {Object.values(MODES).map((m) => (
                <button
                    key={m.key}
                    type="button"
                    role="option"
                    aria-selected={mode === m.key}
                    className={`mode-menu-item${mode === m.key ? " active" : ""}`}
                    onClick={() => onSelect(m.key)}
                >
          <span className={`mode-menu-icon${m.key === "manual" ? " mode-menu-icon-plain" : ""}`}>
            {m.key === "ai" ? <AiAvatar size={26} /> : <PinIcon size={18} />}
          </span>
                    <span className="mode-menu-text">
            <span className="mode-menu-title">{m.title}</span>
            <span className="mode-menu-sub">{m.subtitle}</span>
          </span>
                </button>
            ))}
        </div>
    );
});